import React from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import RoundedButton from '../Actions/RoundedButton'
import DisplayText from '../Texts/DisplayText'
import cx from 'classnames'
import { ruleValidation } from './customFunctions'

const styles = makeStyles(theme => ({
    smallTitle: {
        fontSize: 14,
        fontWeight: 500,
        color: '#607D8B'
    },
}))

const ButtonsSelect = ({ data, onChange, disabled }) => {

    const classes = styles()

    const { value, error, isVisited, isRequired, isValid, options, config, rules } = data
    const { id, label, helper, fullWidth } = config

    const selected = options.find(e => e.value === value)
    const _color = selected ? selected.color : 'primary'

    const onInnerChange = value => {
        let temp = { ...data }
        temp.value = value
        temp.isValid = ruleValidation(temp.value, temp.rules);
        temp.isVisited = true;
        console.log(temp)
        onChange(temp)
    }

    return (
        <Grid container justify='center' spacing={4}>
            <Grid item xs={12}>
                <DisplayText className={classes.smallTitle} >{label}</DisplayText>
            </Grid>
            {options.map(item => (
                <Grid item>
                    <RoundedButton disabled={disabled} color={item.value === value ? _color : 'grey'} onClick={() => onInnerChange(item.value)}>
                        {item.label}
                    </RoundedButton>
                </Grid>
            ))}
        </Grid>
    )
}

export default ButtonsSelect